import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductSaleAuditReportData} from "./product-sale-audit-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductSaleAuditReportModel extends ReportModel<ProductSaleAuditReportData> {
    constructor(injector: Injector) {
        super(injector, ProductSaleAuditReportData);
    }
}
